/** @jsxRuntime classic */
/** @jsx jsx */
import { useState, useRef, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { jsx, Button, Input, Label } from "theme-ui";

import api, { errorMessage } from "../utils/api";

export default function ResetPassword() {
  const { uid, token } = useParams();
  const history = useHistory();

  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [done, setDone] = useState(false);
  const inputRef = useRef();

  useEffect(() => {
    if (inputRef.current) inputRef.current.focus();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError(false);

    if (password !== confirmation) {
      setError("Those passwords don't match.");
      return;
    }

    setLoading(true);
    api
      .post("/api/password-reset/confirm/", { uid, token, password })
      .then(() => {
        setLoading(false);
        setDone(true);
      })
      .catch((err) => {
        setLoading(false);
        setError(
          errorMessage(
            err,
            "We couldn't reset your password. Please try again.",
          ),
        );
      });
  };

  if (done) {
    return (
      <div sx={formSx}>
        <h1 sx={headingSx}>Password updated</h1>
        <p sx={{ lineHeight: 1.5 }}>
          Your password has been changed. You can now sign in with it.
        </p>
        <Button
          sx={{ width: "100%" }}
          onClick={() => history.push("/login")}
        >
          Go to login
        </Button>
      </div>
    );
  }

  return (
    <form sx={formSx} onSubmit={handleSubmit}>
      <h1 sx={headingSx}>Choose a new password</h1>
      {error && <div sx={errorSx}>{error}</div>}
      <Label htmlFor="password">New password</Label>
      <Input
        name="password"
        type="password"
        placeholder="Enter a new password"
        required
        ref={inputRef}
        onChange={(e) => setPassword(e.target.value)}
      />
      <Label htmlFor="confirmation" sx={{ mt: 3 }}>
        Confirm new password
      </Label>
      <Input
        name="confirmation"
        type="password"
        placeholder="Enter it again"
        required
        onChange={(e) => setConfirmation(e.target.value)}
      />
      <Button sx={{ width: "100%", my: 36 }} type="submit" disabled={loading}>
        {loading ? "Saving..." : "Set password"}
      </Button>
      <div sx={{ fontSize: "90%", textAlign: "center", color: "black" }}>
        <a
          sx={{ variant: "components.link", color: "red" }}
          href="/forgot-password"
        >
          Request a new link
        </a>
      </div>
    </form>
  );
}

const formSx = {
  width: "90%",
  maxWidth: 500,
  p: [10, 50],
  mx: "auto",
};

const headingSx = {
  textAlign: "left",
  my: 0,
  fontSize: 55,
  fontWeight: 300,
  fontFamily: "heading",
};

const errorSx = {
  backgroundColor: "error",
  color: "white",
  padding: 20,
  mb: 30,
  fontSize: 14,
};
